<template>
    <div class="sm:mb-4 p-6 text-white bg-gray-900 bg-primary-cta bg-no-repeat items-center justify-center flex transition duration-500 ease-in-out mt-0 sm:rounded w-full h-full">
        <tw-card height="bg-gray-800 sm:bg-gray-800 w-auto text-gray-900 relative text-white transition duration-500 ease-in-out mt-6">
            <racing-stars-icon class="rounded-full absolute -top-2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-white p-2 bg-gray-800 text-white transition duration-500 ease-in-out text-racing-stars-yellow" />

            <h2 class="text-white uppercase flex w-full justify-center mb-4 text-center px-4 pt-4">{{ title }}</h2>

            <span class="text-white uppercase text-1xl flex w-full justify-center text-center">You Get</span>

            <span class="flex w-full justify-center font-bold text-center text-4xl text-racing-stars-yellow uppercase mb-2">10 Tokens</span>

            <span class="text-white uppercase text-1xl flex w-full justify-center text-center">Your Referral Gets</span>

            <span class="flex w-full justify-center font-bold text-center text-4xl text-racing-stars-yellow uppercase mb-4">10 Tokens</span>

            <tw-button class="text-gray-800 bg-racing-stars-yellow w-full" @click="account()">Get Started</tw-button>
        </tw-card>
    </div>
</template>
<script>
import { computed, ref } from 'vue'
import TwCard from '@/Global/Elements/TwCard'
import TwButton from '@/Global/Elements/TwButton'
import RacingStarsIcon from '@/Global/RacingStarsIcon'
import { getCurrentInstance } from 'vue'
import moment from 'moment'
import Counter from 'vue3-autocounter';
import { Inertia } from '@inertiajs/inertia'

export default {
    emits: ['bet'],

    props: {
        title: {
            type: String,
            default: 'Earn Tokens by Referring Your Friends',
        },
        showAction: {
            type: Boolean,
            default: true,
        },
        showBetButton: {
            type: Boolean,
            default: false,
        }
    },
    components: {
        TwButton,
        TwCard,
        RacingStarsIcon,
        Counter,
    },
    setup(props, { emit }) {

        const dailyJackpot = ref(null)

        const weeklyJackpot = ref(null)

        /**
         * Formatter function required to format currencies/prices correctly.
         * 
         * @type {Intl}
         */
        const formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
        })

        const account = () => {
            Inertia.get(route('account'))
        }

        const placeBet = () => {
            emit('bet')
        }

        const restartDaily = () => {
            if (dailyJackpot.value) {
                dailyJackpot.value.reset()
                dailyJackpot.value.start()
            }
        }

        const restartWeekly = () => {
            if (weeklyJackpot.value) {
                weeklyJackpot.value.reset()
                weeklyJackpot.value.start()
            }
        }

        const duration = (jackpot) => {
            return (parseInt(jackpot) / 100) * 6
        }

        return {
            formatter,
            account,
            dailyJackpot,
            weeklyJackpot,
            placeBet,
            restartDaily,
            restartWeekly,
            duration,
        }
    }
}

</script>
